import { render, staticRenderFns } from "./announcementCate.vue?vue&type=template&id=dfadd57a&scoped=true&"
import script from "./announcementCate.vue?vue&type=script&lang=js&"
export * from "./announcementCate.vue?vue&type=script&lang=js&"
import style0 from "./announcementCate.vue?vue&type=style&index=0&id=dfadd57a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfadd57a",
  null
  
)

export default component.exports